import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useEffect } from 'react';
import { formatDate } from '@libs/hooks';
import Typography from '../../typography/Typography';
import Toggle from '../../toggle/Toggle';
import Button from '../../button/Button';
import { SelectFilterContainer } from '../../select-filter-container/SelectFilterContainer';
import { CloseIcon } from '../../assets';
import Input from '../../input/Input';
import { useDateFilter, } from './hooks/useDateFilter';
import { ActionsSeparator, DatesSeparator, DatesWrapper, ExactDayToggleWrapper, ActionsWrapper, CalendarWrapper, CloseIconWrapper, EmptyDiv, CalendarTitle, } from './styles';
export { CalendarStyle } from './styles';
export const DEFAULT_DATE_FILTER_FORMAT = 'YYYY/MM/DD';
const DateFilter = ({ label, defaultValue, exactDayLabel, clearButtonTitle, filterButtonTitle, onFilter, onClear, clearDate, setClearDate, className, CalendarComponent, secondInputPlaceholder, firstInputPlaceholder, calendarTitle, calendarPublishTitle, isExactDayFilter, renderFooter, shouldHideExactDayToggler, shouldHideRangeFilters, selectButtonTitle, buttonSize, shouldNotHaveMaxDate, publishLabel, }) => {
    const { to, from, isOpen, maxDate, selectedDates, selectedDatesLabel, isExactDaySelected, handleCalendarWrapperClick, setIsExactDaySelected, handleInputChange, setSelectedDates, toggleSelect, closeFilter, onBlur, } = useDateFilter(isExactDayFilter, defaultValue);
    const isFiltered = Boolean(selectedDatesLabel);
    const handleCalendarOpen = (e) => {
        e.stopPropagation();
        toggleSelect();
    };
    const handleFilter = () => {
        closeFilter();
        if (Array.isArray(selectedDates)) {
            if (selectedDates[0] && !selectedDates[1]) {
                onFilter([selectedDates[0], selectedDates[0]]);
            }
            else {
                onFilter(selectedDates);
            }
        }
        else if (selectedDates === defaultValue || !selectedDates) {
            return;
        }
        else {
            //  this hepens when exact date is selected and we are returning same maxDate and minDate
            onFilter([selectedDates, selectedDates]);
        }
    };
    const handleClear = useCallback(() => {
        closeFilter();
        onClear();
        setSelectedDates(defaultValue);
    }, [closeFilter, onClear, setSelectedDates, defaultValue]);
    useEffect(() => {
        if (clearDate) {
            handleClear();
            setClearDate?.(false);
        }
    }, [clearDate, handleClear, setClearDate]);
    const hasDatesSelected = Boolean(selectedDates);
    const handleFormatMonthYear = (locale, date) => {
        return formatDate('MMMM YYYY', date);
    };
    const handleFormatShortWeekday = (locale, date) => {
        return formatDate('ddd', date);
    };
    const handleToggleClick = (val) => {
        if (!isExactDayFilter) {
            setIsExactDaySelected(val);
        }
    };
    const selectedValue = Array.isArray(selectedDates) && !selectedDates[1]
        ? selectedDates[0]
        : selectedDates;
    const calendarComponent = (_jsxs(CalendarWrapper, { children: [_jsxs(CalendarTitle, { children: [_jsx(EmptyDiv, {}), _jsx(Typography, { type: 'subHeadline', fontFamily: 'primaryBold', children: calendarPublishTitle || calendarTitle }), _jsx(CloseIconWrapper, { onClick: closeFilter, children: _jsx(CloseIcon, {}) })] }), !shouldHideExactDayToggler && (_jsxs(ExactDayToggleWrapper, { children: [_jsx(Typography, { type: "bodyButton", children: exactDayLabel }), _jsx(Toggle, { labelSize: "1.9rem", checked: isExactDaySelected, onChangeValue: handleToggleClick })] })), !shouldHideRangeFilters && (_jsxs(DatesWrapper, { children: [_jsx(Input, { name: "from", inputMode: "decimal", placeholder: firstInputPlaceholder, value: from, onChange: handleInputChange, onBlur: onBlur, maxLength: 8 }), _jsx(DatesSeparator, {}), _jsx(Input, { name: "to", placeholder: secondInputPlaceholder, inputMode: "decimal", value: to, disabled: isExactDaySelected, onChange: handleInputChange, onBlur: onBlur, maxLength: 8 })] })), _jsx(CalendarComponent, { selectRange: !isExactDaySelected, maxDate: !shouldNotHaveMaxDate ? maxDate : undefined, returnValue: "range", value: selectedValue, onChange: setSelectedDates, formatMonthYear: handleFormatMonthYear, formatShortWeekday: handleFormatShortWeekday }), renderFooter?.(), _jsxs(ActionsWrapper, { children: [_jsx(Button, { size: buttonSize || 'sm', onClick: handleClear, buttonType: "secondary", title: clearButtonTitle }), _jsx(ActionsSeparator, {}), _jsx(Button, { size: buttonSize || 'sm', onClick: handleFilter, title: selectButtonTitle || filterButtonTitle })] })] }));
    return (_jsx(SelectFilterContainer, { className: className, closeFilter: closeFilter, hasDatesSelected: hasDatesSelected, label: publishLabel || label, handleOpenModal: handleCalendarOpen, handleCalendarWrapperClick: handleCalendarWrapperClick, toggleSelect: toggleSelect, isFiltered: isFiltered, isOpen: isOpen, selectedDatesLabel: selectedDatesLabel, children: calendarComponent }));
};
export default DateFilter;
//# sourceMappingURL=DateFilter.js.map